<script>
    import Chart from 'chart.js';
    import Common from '../public/lib/common';

    export let labelsData;
    export let valuesData;
    export let valuesData2;
    export let titleData;
    export let stackedData;

    let outer = Common.randomString();
    let inner = Common.randomString();

    export function setup() {

        let w = jQuery('#' + outer).width();
        let ht = Math.max(500, w / 4);
        jQuery('#' + outer).css({'height': ht + 'px'});
        jQuery('#' + inner).css({'width': w + 'px'});
        jQuery('#' + inner).css({'height': ht - 10 + 'px'});

        if (labelsData && labelsData.length > 0) {
            let colors = Array(labelsData.length).fill("#089c30");
            let colors2 = Array(labelsData.length).fill("#a21f19");
            new Chart(document.getElementById(inner), {
                type: 'bar',
                data: {
                    labels: labelsData,
                    datasets: [
                        {
                            label: titleData,
                            backgroundColor: colors,
                            data: valuesData
                        },
                        {
                            label: titleData,
                            backgroundColor: colors2,
                            data: valuesData2
                        }
                    ]
                },
                options: {
                    plugins: {
                        labels: false
                    },
                    scales: {
                        xAxes: [{
                            stacked: stackedData,
                            ticks: {
                                fontColor: "#FFF"
                            }
                        }],
                        yAxes: [{
                            stacked: stackedData,
                            ticks: {
                                fontColor: "#FFF"
                            }
                        }]
                    },
                    responsive: true,
                    legend: {
                        display: false,
                        labels: {
                            fontColor: "#fff"
                        }
                    },
                    title: {
                        display: true,
                        fontSize: 18,
                        fontColor: '#fff',
                        text: titleData
                    },
                }
            });
        }
    };

</script>

<main class="chart-container" id="{outer}">
    <canvas id="{inner}">
    </canvas>
</main>

<style>

</style>


